var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
var LocationOnGlobeIcon = forwardRef(function (props, svgRef) {
    var _a = props.color, color = _a === void 0 ? 'currentColor' : _a, _b = props.size, size = _b === void 0 ? 24 : _b, rest = __rest(props, ["color", "size"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, strokeWidth: 1, strokeLinecap: "round", strokeLinejoin: "round", ref: svgRef }, rest),
        React.createElement("path", { d: "M7.503 6.569l1.125 1.313.93 1.162-.094 1.596-1.86.345-1.31 1.549.612 1.267.59 1.057 1.39 1.077-.911 1.382-1.222.534M11.706 20l.607-1.364-.542-1.893.78-2.05 2.248-.418 1.9.804 1.389 1.77M19.288 10.934a7.46 7.46 0 11-6.075-5.767", stroke: color, strokeWidth: 1.5, strokeMiterlimit: 10 }),
        React.createElement("path", { d: "M15.727 8.267a1.067 1.067 0 100-2.133 1.067 1.067 0 000 2.133z", stroke: color, strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "square" }),
        React.createElement("path", { d: "M18.927 7.117c0 1.924-3.2 4.883-3.2 4.883s-3.2-2.959-3.2-4.883a3.131 3.131 0 013.2-3.116 3.133 3.133 0 013.2 3.116v0z", stroke: color, strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "square" })));
});
LocationOnGlobeIcon.displayName = 'LocationOnGlobeIcon';
export default LocationOnGlobeIcon;
